module.exports = __webpack_public_path__ + "img/eu.510ca6da.svg";